
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as libraryPHryiNh1Ml3CkG1is0H4_45DibPKkuZz12sWn0W_45LTGrwMeta } from "/uiquran/pages/library.vue?macro=true";
import { default as index3JKBOdMSfk63oQtxwcEUlYqoNlWahE2uA81k9Dz6jwwMeta } from "/uiquran/pages/home/index.vue?macro=true";
import { default as indexJsOCC_5PNG2d9KVM2zmQQ_h1Ru9iTGv2o_45DRbj5dvlNqYMeta } from "/uiquran/pages/ayah/indexJs.js?macro=true";
import { default as slugJsJ3olsYuvepVtgszxO5dbmPgX_45EyF1rRiw7Qm3in7dNIMeta } from "/uiquran/pages/quran/slugJs.js?macro=true";
import { default as indexI4Aw71jFL0sLuL_45kyZeJrHf0zVtt0wxklSZ5YOpzcqsMeta } from "/uiquran/pages/surah/index.vue?macro=true";
import { default as index63uGEHgwPybHnjWTq30Gu44W4OcNFHfickIqHs5LnRAMeta } from "/uiquran/pages/search/index.vue?macro=true";
import { default as index_sy2Ttj7RxiVVDcSM85JmQaoNR8MgZ6iwois4M8dFNUMeta } from "/uiquran/pages/aisearch/index.vue?macro=true";
import { default as index83SSVwVR4oHnZXenYh5X9PeD_BhifCx4ffV5r9reFUgMeta } from "/uiquran/pages/analysis/index.vue?macro=true";
import { default as _91_46_46_46slug_93qCF9AiBxi5LULw13eSluq7lAmtgU42B9k7R6JXHo9awMeta } from "/uiquran/pages/ayah/[...slug].vue?macro=true";
import { default as _91_91id_93_93wnZDNT4xQVMbojT3StEq7bjlsq_CB_459l_45jun2nVFXncMeta } from "/uiquran/pages/subject/[[id]].vue?macro=true";
import { default as _91_46_46_46slug_93_45W_45t853sIeI0y2JDNc_451Aa4YBfcvJo4tbHh_F4SZGMcMeta } from "/uiquran/pages/quran/[...slug].vue?macro=true";
import { default as index44dfxRQan7Cq4_45pewfdk8nrrmrOVV8XqBiX2GFi9GGUMeta } from "/uiquran/pages/propername/index.vue?macro=true";
import { default as _91_46_46_46slug_93DGVzqHW2jYO9zLmF8ZiN9FP8YtiAnClilZb61GToEFgMeta } from "/uiquran/pages/vocabulary/[...slug].vue?macro=true";
import { default as vocabularybwXFjjSRPiDhy2WfWge_45YZDOEbB2vP4y1CIndX6B4jYMeta } from "/uiquran/pages/vocabulary/vocabulary.js?macro=true";
import { default as _91_46_46_46section_93W3IYeMzOgKKWdVrPKGvg7YgNxYPyNUGKm6_45b2PU9zZgMeta } from "/uiquran/pages/surah/[id]/[...section].vue?macro=true";
import { default as _91_46_46_46section_93oCA9Xx6SrQg1Y4FPVMt4fJtgaWaw9vVRIcSwmgFqcEwMeta } from "/uiquran/pages/propername/[id]/[...section].vue?macro=true";
import { default as generalyAD8zkL6zQvYiXMRiTrpA98sztt5c0lkjpTyNj2FDVYMeta } from "~/pages/general.vue?macro=true";
export default [
  {
    name: "library___en",
    path: "/en/library",
    component: () => import("/uiquran/pages/library.vue")
  },
  {
    name: "library___ar",
    path: "/ar/library",
    component: () => import("/uiquran/pages/library.vue")
  },
  {
    name: "library___fa",
    path: "/fa/library",
    component: () => import("/uiquran/pages/library.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    component: () => import("/uiquran/pages/home/index.vue")
  },
  {
    name: "home___ar",
    path: "/ar/home",
    component: () => import("/uiquran/pages/home/index.vue")
  },
  {
    name: "home___fa",
    path: "/fa/home",
    component: () => import("/uiquran/pages/home/index.vue")
  },
  {
    name: "ayah-indexJs___en",
    path: "/en/ayah/indexJs",
    component: () => import("/uiquran/pages/ayah/indexJs.js")
  },
  {
    name: "ayah-indexJs___ar",
    path: "/ar/ayah/indexJs",
    component: () => import("/uiquran/pages/ayah/indexJs.js")
  },
  {
    name: "ayah-indexJs___fa",
    path: "/fa/ayah/indexJs",
    component: () => import("/uiquran/pages/ayah/indexJs.js")
  },
  {
    name: "quran-slugJs___en",
    path: "/en/quran/slugJs",
    component: () => import("/uiquran/pages/quran/slugJs.js")
  },
  {
    name: "quran-slugJs___ar",
    path: "/ar/quran/slugJs",
    component: () => import("/uiquran/pages/quran/slugJs.js")
  },
  {
    name: "quran-slugJs___fa",
    path: "/fa/quran/slugJs",
    component: () => import("/uiquran/pages/quran/slugJs.js")
  },
  {
    name: "surah___en",
    path: "/en/surah",
    component: () => import("/uiquran/pages/surah/index.vue")
  },
  {
    name: "surah___ar",
    path: "/ar/surah",
    component: () => import("/uiquran/pages/surah/index.vue")
  },
  {
    name: "surah___fa",
    path: "/fa/surah",
    component: () => import("/uiquran/pages/surah/index.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/uiquran/pages/search/index.vue")
  },
  {
    name: "search___ar",
    path: "/ar/search",
    component: () => import("/uiquran/pages/search/index.vue")
  },
  {
    name: "search___fa",
    path: "/fa/search",
    component: () => import("/uiquran/pages/search/index.vue")
  },
  {
    name: "aisearch___en",
    path: "/en/aisearch",
    component: () => import("/uiquran/pages/aisearch/index.vue")
  },
  {
    name: "aisearch___ar",
    path: "/ar/aisearch",
    component: () => import("/uiquran/pages/aisearch/index.vue")
  },
  {
    name: "aisearch___fa",
    path: "/fa/aisearch",
    component: () => import("/uiquran/pages/aisearch/index.vue")
  },
  {
    name: "analysis___en",
    path: "/en/analysis",
    component: () => import("/uiquran/pages/analysis/index.vue")
  },
  {
    name: "analysis___ar",
    path: "/ar/analysis",
    component: () => import("/uiquran/pages/analysis/index.vue")
  },
  {
    name: "analysis___fa",
    path: "/fa/analysis",
    component: () => import("/uiquran/pages/analysis/index.vue")
  },
  {
    name: "ayah-slug___en",
    path: "/en/ayah/:slug(.*)*",
    component: () => import("/uiquran/pages/ayah/[...slug].vue")
  },
  {
    name: "ayah-slug___ar",
    path: "/ar/ayah/:slug(.*)*",
    component: () => import("/uiquran/pages/ayah/[...slug].vue")
  },
  {
    name: "ayah-slug___fa",
    path: "/fa/ayah/:slug(.*)*",
    component: () => import("/uiquran/pages/ayah/[...slug].vue")
  },
  {
    name: "subject-id___en",
    path: "/en/subject/:id?",
    component: () => import("/uiquran/pages/subject/[[id]].vue")
  },
  {
    name: "subject-id___ar",
    path: "/ar/subject/:id?",
    component: () => import("/uiquran/pages/subject/[[id]].vue")
  },
  {
    name: "subject-id___fa",
    path: "/fa/subject/:id?",
    component: () => import("/uiquran/pages/subject/[[id]].vue")
  },
  {
    name: "quran-slug___en",
    path: "/en/quran/:slug(.*)*",
    component: () => import("/uiquran/pages/quran/[...slug].vue")
  },
  {
    name: "quran-slug___ar",
    path: "/ar/quran/:slug(.*)*",
    component: () => import("/uiquran/pages/quran/[...slug].vue")
  },
  {
    name: "quran-slug___fa",
    path: "/fa/quran/:slug(.*)*",
    component: () => import("/uiquran/pages/quran/[...slug].vue")
  },
  {
    name: "propername___en",
    path: "/en/propername",
    component: () => import("/uiquran/pages/propername/index.vue")
  },
  {
    name: "propername___ar",
    path: "/ar/propername",
    component: () => import("/uiquran/pages/propername/index.vue")
  },
  {
    name: "propername___fa",
    path: "/fa/propername",
    component: () => import("/uiquran/pages/propername/index.vue")
  },
  {
    name: "vocabulary-slug___en",
    path: "/en/vocabulary/:slug(.*)*",
    component: () => import("/uiquran/pages/vocabulary/[...slug].vue")
  },
  {
    name: "vocabulary-slug___ar",
    path: "/ar/vocabulary/:slug(.*)*",
    component: () => import("/uiquran/pages/vocabulary/[...slug].vue")
  },
  {
    name: "vocabulary-slug___fa",
    path: "/fa/vocabulary/:slug(.*)*",
    component: () => import("/uiquran/pages/vocabulary/[...slug].vue")
  },
  {
    name: "vocabulary-vocabulary___en",
    path: "/en/vocabulary/vocabulary",
    component: () => import("/uiquran/pages/vocabulary/vocabulary.js")
  },
  {
    name: "vocabulary-vocabulary___ar",
    path: "/ar/vocabulary/vocabulary",
    component: () => import("/uiquran/pages/vocabulary/vocabulary.js")
  },
  {
    name: "vocabulary-vocabulary___fa",
    path: "/fa/vocabulary/vocabulary",
    component: () => import("/uiquran/pages/vocabulary/vocabulary.js")
  },
  {
    name: "surah-id-section___en",
    path: "/en/surah/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/surah/[id]/[...section].vue")
  },
  {
    name: "surah-id-section___ar",
    path: "/ar/surah/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/surah/[id]/[...section].vue")
  },
  {
    name: "surah-id-section___fa",
    path: "/fa/surah/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/surah/[id]/[...section].vue")
  },
  {
    name: "propername-id-section___en",
    path: "/en/propername/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/propername/[id]/[...section].vue")
  },
  {
    name: "propername-id-section___ar",
    path: "/ar/propername/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/propername/[id]/[...section].vue")
  },
  {
    name: "propername-id-section___fa",
    path: "/fa/propername/:id()/:section(.*)*",
    component: () => import("/uiquran/pages/propername/[id]/[...section].vue")
  },
  {
    name: "general-privacy___en",
    path: "/en/privacy",
    props: {"page":"privacy"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-privacy___ar",
    path: "/ar/privacy",
    props: {"page":"privacy"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-privacy___fa",
    path: "/fa/privacy",
    props: {"page":"privacy"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutwebsite___en",
    path: "/en/aboutwebsite",
    props: {"page":"aboutwebsite"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutwebsite___ar",
    path: "/ar/aboutwebsite",
    props: {"page":"aboutwebsite"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutwebsite___fa",
    path: "/fa/aboutwebsite",
    props: {"page":"aboutwebsite"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-termsconditions___en",
    path: "/en/termsconditions",
    props: {"page":"termsconditions"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-termsconditions___ar",
    path: "/ar/termsconditions",
    props: {"page":"termsconditions"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-termsconditions___fa",
    path: "/fa/termsconditions",
    props: {"page":"termsconditions"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-contactus___en",
    path: "/en/contactus",
    props: {"page":"contactus"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-contactus___ar",
    path: "/ar/contactus",
    props: {"page":"contactus"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-contactus___fa",
    path: "/fa/contactus",
    props: {"page":"contactus"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutquran___en",
    path: "/en/aboutquran",
    props: {"page":"aboutquran"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutquran___ar",
    path: "/ar/aboutquran",
    props: {"page":"aboutquran"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-aboutquran___fa",
    path: "/fa/aboutquran",
    props: {"page":"aboutquran"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-related_ayah___en",
    path: "/en/related_ayah",
    props: {"page":"related_ayah"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-related_ayah___ar",
    path: "/ar/related_ayah",
    props: {"page":"related_ayah"},
    component: () => import("~/pages/general.vue")
  },
  {
    name: "general-related_ayah___fa",
    path: "/fa/related_ayah",
    props: {"page":"related_ayah"},
    component: () => import("~/pages/general.vue")
  }
]